/**
 * The product limit for a company's DEFAULT tax rate, and the one message for breaking it.
 *
 * Operator ruling 2026-09-24 (docs/PRODUCT_DECISIONS.md, "Default tax rates are limited to
 * 20%"): every editor of company_settings.default_tax_rate accepts 0 through 20 inclusive.
 * Before this, four editors of the same column disagreed — onboarding Pricing said 20 but
 * warned at 15 and clamped, onboarding Financial clamped silently, Rates & Pricing allowed
 * 99.99 and Invoicing 100. The numeric(6,4) column is storage capacity, not the rule.
 *
 * A value above the limit is REFUSED with this message, never clamped: clamping stores a rate
 * the contractor did not type and then quotes customers from it.
 */
export const DEFAULT_TAX_RATE_MIN = 0;
export const DEFAULT_TAX_RATE_MAX = 20;

export const DEFAULT_TAX_RATE_RANGE_TEXT = `${DEFAULT_TAX_RATE_MIN}% to ${DEFAULT_TAX_RATE_MAX}%`;

/** Returns an error message, or null when the value is acceptable. Empty is left to the caller. */
export const defaultTaxRateError = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return 'Enter the tax rate as a number';
  if (n < DEFAULT_TAX_RATE_MIN || n > DEFAULT_TAX_RATE_MAX) {
    return `Default tax rate must be between ${DEFAULT_TAX_RATE_RANGE_TEXT}`;
  }
  return null;
};
